import styled from 'vue3-styled-components';

export const OrderModifyDiv = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    min-height: calc(100vh - 90px);
`;

export const OrderUpClientArea = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: #fff5e6;
    border: 2px solid #fb8b24;
    border-radius: 10px;
    min-width: 500px;
    max-width: 550px;
    min-height: 500px; // 최소 높이 설정
    max-height: calc(100vh - 110px); // 최대 높이는 viewport 높이 기준
    overflow-y: auto; // 세로 스크롤만 생성
    overflow-x: hidden; // 가로 스크롤 제거
    
    &::-webkit-scrollbar {
        width: 8px;  // 스크롤바 너비
    }
    
    &::-webkit-scrollbar-track {
        background: #fff5e6;  // 배경색을 컨테이너와 동일하게
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #fb8b24;  // 주문서의 주요 색상
        border-radius: 4px;
        border: 2px solid #fff5e6;  // 배경색과 같은 테두리 추가
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #e67e00;  // 호버 시 약간 어두운 색상
    }

    &::-webkit-scrollbar-corner {
        background: #fff5e6;  // 스크롤바 모서리 색상
    }
`;

// !품목 주문서 Area
export const OrderModifyProductArea = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 15px;
`;

export const OrderUpClientBtnContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-left: 30px;
`;

// 매장 주문품목 영역
export const StoreOrderArea = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: #fff5e6;
    border: 2px solid #fb8b24;
    border-radius: 10px;
`;

export const OrderModifyCenterArea = styled.div`
    width: 0.45%;
`;

export const OrderModifyFooterArea = styled.div`
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #fff;
    height: 90px;
    box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
    margin-top: 20px;
    z-index: 3;
`;

export const OrderUpProductTableContainer = styled.div`
    border: 1px solid #fb8b24;
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    margin-top: 10px;
`;

// 매장 주문품목 테이블
export const StoreOrderTable = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
    font-size: 13px;
    
    thead tr:first-child {
        th:first-child {
            border-top-left-radius: 10px;
        }
        th:last-child {
            border-top-right-radius: 10px;
        }
    }

    th {
        background: #fb8b24;
        border-top: 1px solid #fb8b24;
    }

    th, td {
        padding: 4px;
        text-align: center;
        vertical-align: middle;
        border-bottom: 1px solid #fb8b24;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    td {
        background: #fff;
        position: relative;
    }

    // 기본 컬럼 너비 (본인부담금 없을 때 - 12개 컬럼)
    th:nth-child(1) { width: 3%; }   // 선택
    th:nth-child(2) { width: 13%; }  // 바코드
    th:nth-child(3) { width: 10%; }  // 품목분류
    th:nth-child(4) { width: 12%; }  // 품목명
    th:nth-child(5) { width: 4%; }   // 사이즈
    th:nth-child(6) { width: 5%; }   // 색상
    th:nth-child(7) { width: 10%; }  // 비고
    th:nth-child(8) { width: 5%; }   // 수량
    th:nth-child(9) { width: 7%; }   // 단가
    th:nth-child(10) { width: 7%; }  // 차액
    th:nth-child(11) { width: 7%; }  // 합계
    th:nth-child(12) { width: 3%; }  // 삭제버튼
    th:nth-child(13) { width: 3%; }  // 상세 버튼

    // 본인부담금 컬럼이 있을 때 (13개 컬럼) - 산소발생기 주문서
    &.oxygen-order {
      th:nth-child(1) { width: 3%; }   // 선택
      th:nth-child(2) { width: 11%; }  // 바코드
      th:nth-child(3) { width: 10%; }  // 품목분류
      th:nth-child(4) { width: 12%; }  // 품목명
      th:nth-child(5) { width: 4%; }   // 사이즈
      th:nth-child(6) { width: 5%; }   // 색상
      th:nth-child(7) { width: 10%; }   // 비고
      th:nth-child(8) { width: 5%; }   // 수량
      th:nth-child(9) { width: 5%; }   // 단가
      th:nth-child(10) { width: 6%; }  // 차액
      th:nth-child(11) { width: 6%; }  // 합계
      th:nth-child(12) { width: 6%; }  // 본인부담금
      th:nth-child(13) { width: 3%; }  // 삭제버튼
      th:nth-child(14) { width: 3%; }  // 상세 버튼
    }

    .main-row {
        transition: all 0.3s ease;
    }

    input, select {
        width: 90%;
        padding: 2px;
        font-size: 12px;
    }
`;

export const ExpandButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    
    &:hover {
        color: #cc5803;
    }
`;

// * 확장된 행 스타일
export const ProductExpandedRowStyles = `
  .product-expanded-row {
    padding: 8px;
    background-color: #f8f9fa;
    border-radius: 6px;
    margin: 4px 0;
    text-align: center;
  }

  .product-expanded-row .product-card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 8px;
  }

  .product-expanded-row .product-info-card {
    background-color: white;
    border-radius: 6px;
    padding: 12px 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    height: 70px; /* 카드 높이 증가 */
    align-items: center;
    justify-content: center;
  }

  .product-expanded-row .product-card-title {
    font-size: 12px;
    font-weight: 600;
    color: #495057;
    margin: 0 0 12px 0; /* 마진 증가 */
    padding-bottom: 3px; /* 패딩 증가 */
    border-bottom: 1px solid #e9ecef;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: center;
    width: 100%;
  }

  .product-expanded-row .product-price-row {
    display: flex;
    justify-content: center;
    gap: 8px;
    width: 100%;
    flex: 1; /* 남은 공간 채우기 */
    align-items: center;
  }

  .product-expanded-row .product-price-item {
    flex: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  .product-expanded-row .product-info-label {
    font-size: 11px;
    color: #6c757d;
    margin-bottom: 5px; /* 마진 증가 */
    text-align: center;
  }

  .product-expanded-row .product-price-value {
    font-size: 14px;
    font-weight: 600;
    color: #0f4c5c;
    text-align: center;
  }

  .product-expanded-row .product-toggle-switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 5px;
  }

  .product-expanded-row .product-toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .product-expanded-row .product-toggle-switch .slider {
    position: relative;
    display: inline-block;
    width: 35px;
    height: 18px;
    background-color: #e9ecef;
    transition: 0.2s;
    border-radius: 20px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .product-expanded-row .product-toggle-switch .slider:before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.2s;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .product-expanded-row .product-toggle-switch input:checked + .slider {
    background-color: #0f4c5c;
  }

  .product-expanded-row .product-toggle-switch input:checked + .slider:before {
    transform: translateX(16px);
  }
`;

export const OrderUpProductTableTheadTr = styled.tr`
    background-color: #fb8b24;
    color: #000;
    height: 40px;

    th {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const OrderUpClientInputTxtW80per = styled.input`
    width: 293px;
    height: 30px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0 8px;
    margin: 1px 0;
`;

export const OrderUpProductTableColorSelect = styled.select`
    width: 100%;
    height: 33px;
    padding: 0 5px;
    border: 1px solid #ccc;
    border-radius: 3px;
`;

// !버튼 영역
export const OrderModifySubmitBtn = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #0f4c5c;
    color: #fff;
    width: 100%;
    height: 27px;
    margin: 5px;
    border-radius: 3px;
    box-shadow: 0 8px 9px -4px rgba(0, 0, 0, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    padding: 15px;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
      }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const OrderModifyServiceBtn = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 180px;
    padding: 15px;
    border-radius: 5px;
    background: #fbffff;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 8px 9px -4px rgba(0, 0, 0, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    margin: 5px;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
      }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const OrderModifySubmitBtnArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70%;
    height: 100%;
`;

export const OrderModifyServiceBtnArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: 100%;
`;

// !댓글 영역
export const CommentTitleDiv = styled.div`
    font-weight: bold;
    font-size: 15px;
    padding: 10px;
    display: flex;
    align-items: center;
`;

export const CommentTextDiv = styled.div`
    font-size: 15px;
    line-height: 30px;
    padding: 0px 10px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
    width: 100%;

    &.no-border {
        border-bottom: none;
    }
`;

export const CommentImageArea = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-wrap: wrap; // 이미지 줄바꿈
    gap: 10px;
    max-width: 220px; // 이미지 2개 너비 + 간격 (100px * 2 + 20px)
`;

export const CommentContentArea = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    word-break: break-all; // 긴 텍스트 줄바꿈
    
    span {
        display: block;
        width: 100%;
        white-space: pre-wrap; // 줄바꿈 보존
        word-wrap: break-word; // 긴 단어 줄바꿈
        max-width: 30ch; // 약 30자 기준으로 줄바꿈
        line-height: 1.5; // 줄간격 조정
    }
`;


export const CommentImg = styled.img`
    width: 100px;
    height: 100px;
    object-fit: cover;
    cursor: pointer;
`;

export const CloseSpan = styled.span`
    padding-top: 3px;
    cursor: pointer;
    color: #ff0000;

    &:hover {
        color:hsl(0, 100.00%, 72.20%);
    }
`;

export const Feedback = styled.span`
    padding: 5px 10px;
    margin-left: 10px;
    cursor: pointer;
    color: #2E7D32;
    font-weight: 600;
    border-radius: 8px;
    background-color: #E8F5E9;
    border: 2px solid #81C784;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: inline-flex;
    align-items: center;

    &:hover {
        background-color: #C8E6C9;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }

    &:active {
        transform: translateY(1px);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(129, 199, 132, 0.4);
    }
`;

export const CommentThumbnailArea = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 5px;
    position: relative;
`;

export const CommentThumbnail = styled.div`
    margin: 5px;
    position: relative;

    img {
        width:100px;
        object-fit: cover;
    }

    button {
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.7);
        border: none;
        cursor: pointer;
    }
`;

export const CommentImageUploadArea = styled.div`
    button {
        display: flex;
        align-items: center;
        box-shadow: 0 4px 5px -2px rgba(175, 156, 156, 0.3), 0 2px 9px 0 rgba(0, 0, 0, 0.2);
        background: #fff;
        font-weight: bold;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        padding: 5px 10px;
        margin: 5px;
        font-size: 12px;

        &:hover {
            background: #f0f0f0;
        }
    }
`;

export const ImageModal = styled.div`
  position: fixed;
  margin-top: 20px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  img {
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
  }
`;

export const AddressControlContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SwapVerticalIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #666;
  padding-left: 5px;
  transition: all 0.2s ease;

  &:hover {
    color: #333;
    background-color: #f5f5f5;
  }
`;

export const OrderModifyClientTableTd = styled.td`
    text-align: center;
    width: 100%;
    height: 35px;
    font-size: 14px;
    background: #fb8b24;
    color: #000;
`;

export const OrderUpClientInputTxtW150 = styled.input`
    width: 118px;
    height: 30px;
`;

export const OrderUpClientInputTxtW260 = styled.input`
    width: 220px;
    height: 30px;
`;

export const OrderUpClientTable = styled.table`
    width: 87%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-left: 30px;
}`;

export const orderUpClientAddressBtn = styled.button`
    background: #ffc971;
    height: 30px;
    margin: 5px;
    border: 1px solid #fb8b24;
    border-radius: 3px;
    box-shadow: 1px 1px 1px 1px #fb8b24;
    font-size: 15px;
    cursor: pointer;
    width: 123px;
`;

export const OrderUpClientSelectW162 = styled.select`
    width: 130px;
    height: 40px;
`;

export const QuantityFlexDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;  // 요소들 사이 간격
`;

export const QuantityButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
    justify-content: center;
`;

// 기존 버튼 스타일 수정
export const HanqBtn = styled.button`
    padding: 2px 8px;
    font-size: 12px;
    min-width: 24px;
    background: #fb8b24;
    color: #fff;
    border: 1px solid #fb8b24;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background: #f0f0f0;
        color: #000;
    }

    &:active {
        transform: translateY(-1px);
    }
`;

// 수량 입력 필드 스타일 수정
export const OrderupProductCntInput = styled.input`
    width: 40px !important;
    text-align: center;
    margin: 0 2px;
    padding: 2px;
`;

// ! 문서 등록정보 영역
export const DocumentSection = styled.div`
    background: #f5f7fa;
    border-radius: 16px;
    border: 2px solid #0f4c5c;
    padding: 10px;
    padding-top: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    margin-top: 20px;
    position: relative;
    overflow: hidden;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 6px;
    }
`;

export const DocumentHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    position: relative;
`;

export const DocumentTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #0f4c5c;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
`;

export const FileUploadButton = styled.button`
    cursor: pointer;
    border: 0 solid;
    border-radius: 5px;
    color: #fff;
    background: #0f4c5c;
    padding: 6px;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 5px;
    
    &:hover{
        animation: buzz 0.8s ease-in-out;
    }
`;

export const DeleteButton = styled.button`
    padding: 6px;
    background: none;
    border: none;
    color: #ef4444;
    cursor: pointer;
    border-radius: 50%;
    transition: background 0.2s;
    font-size: 16px;
    font-weight: bold;
    display: inline-block;

    &:hover {
        background: #fee2e2;
    }
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin-top: 10px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    overflow: hidden;
`;

export const TableHeader = styled.th`
    width: ${props => props.width || 'auto'};
    background: #0f4c5c;
    color: white;
    padding: 8px 12px;
    text-align: ${props => props.align || 'center'};
    font-weight: 500;
    letter-spacing: 0.3px;
    border: none;
    
    &:first-child {
        border-top-left-radius: 10px;
    }
    
    &:last-child {
        border-top-right-radius: 10px;
    }
    
    input[type="checkbox"] {
        width: 18px;
        height: 18px;
        accent-color: #0f4c5c;
        border-radius: 4px;
        cursor: pointer;
    }
`;

export const TableCell = styled.td`
    padding: 8px 12px;
    text-align: ${props => props.align || 'center'};
    background: white;
    border-bottom: 1px solid #e5e9f0;
    
    &:first-child {
        border-left: 1px solid #e5e9f0;
    }
    
    &:last-child {
        border-right: 1px solid #e5e9f0;
    }
    
    input[type="checkbox"] {
        width: 18px;
        height: 18px;
        accent-color: #0f4c5c;
        cursor: pointer;
    }
`;

export const TableRow = styled.tr`
    transition: background-color 0.2s ease;
    
    &:hover td {
        background-color: #f8fafc;
    }
    
    &:last-child {
        td {
            border-bottom: 1px solid #e5e9f0;
            
            &:first-child {
                border-bottom-left-radius: 10px;
            }
            
            &:last-child {
                border-bottom-right-radius: 10px;
            }
        }
    }
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
`;

export const Thumbnail = styled.img`
    width: 45px;
    height: 45px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    border: 2px solid #e5e9f0;
    
    &:hover {
        border-color: #0f4c5c;
    }
`;

export const EmptyMessage = styled.td`
    text-align: center;
    padding: 32px;
    color: #64748b;
    font-style: italic;
    background: #f8fafc !important;
    font-size: 15px;
`;

export const LoadingMessage = styled.div`
    text-align: center;
    padding: 40px;
    color: #0f4c5c;
    font-size: 16px;
    font-weight: 500;
    background: #f8fafc;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const ClaimLoadingMessage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 60px 40px;
    color: #1e293b;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 16px;
    box-shadow: 
        0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.06);
    border: 1px solid #e2e8f0;
    position: relative;
    overflow: hidden;
    margin: 20px 0;
`;

export const ClaimLoadingSpinner = styled.div`
    width: 48px;
    height: 48px;
    border: 4px solid #e2e8f0;
    border-top: 4px solid #0f4c5c;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 24px;
    position: relative;
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

export const ClaimLoadingText = styled.p`
    margin: 0;
    font-size: 18px;
    color: #374151;
    font-weight: 600;
    letter-spacing: -0.025em;
    position: relative;
    z-index: 1;
    
    @keyframes blink {
        0%, 50% { opacity: 1; }
        51%, 100% { opacity: 0; }
    }
`;

export const PreviewModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.75);
    backdrop-filter: blur(3px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const PreviewContent = styled.div`
    background: white;
    padding: 16px;
    border-radius: 12px;
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

export const PreviewImage = styled.img`
    max-width: 100%;
    max-height: 80vh;
    object-fit: contain;
    border-radius: 6px;
`;

export const ClosePreviewButton = styled.button`
    position: absolute;
    top: 8px;
    right: 8px;
    background: #000;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: 25px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: white;
    z-index: 1001;
    padding-bottom: 4px;
`;

// 합계 영역을 위한 새로운 스타일 컴포넌트 추가
export const OrderTotalArea = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: #ffc971;
    border-left: 1px solid #fb8b24;
    border-right: 1px solid #fb8b24;
    border-bottom: 1px solid #fb8b24;
    border-radius: 0 0 10px 10px;
    margin-top: -2px;
`;

export const TotalInfoContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 0 20px;
    flex: 1;
`;

export const TotalInfoItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: bold;
    font-size: 14px;
    color: #0f4c5c;
`;

export const PaymentMethodContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    margin-right: 260px;
`;

export const PaymentMethodLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-size: 14px;

    input[type="radio"] {
        cursor: pointer;
        margin: 0;
    }
`;

export const SummaryRightContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 20px;
    padding: 0 20px;
    margin-left: auto;
`;

export const ActionButtonContainer = styled.div`
    display: flex;
    gap: 10px;
`;

export const ActionButton = styled.button`
    padding: 8px 16px;
    background: #fff;
    border: 1px solid #fb8b24;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #cc5803;
    
    &:hover {
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(-2px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const SectionTitle2 = styled.h3`
  font-size: 22px;
  font-weight: bold;
  margin: 20px 0 10px;
  padding-left: 10px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #cc5803;
`;

export const OrderTypeTag = styled.span`
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &.normal {
    background-color: #f8f1e9;
    color: #cc5803;
    border: 2px solid #cc5803;
  }
  
  &.rental {
    background-color: #e3f2fd;
    color: #1976d2;
    border: 2px solid #1976d2;
  }
  
  &.oxygen {
    background-color: #f3e5f5;
    color: #6b46c1;
    border: 2px solid #6b46c1;
  }

  &.assistance {
    background-color: #e8f5e9;
    color: #2e7d32;
    border: 2px solid #2e7d32;
  }
  
  &.diabetes {
    background-color: #e0f7f5;
    color: #00998b;
    border: 2px solid #00998b;
  }
  
  &::before {
    content: '●';
    margin-right: 8px;
    font-size: 12px;
    vertical-align: middle;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const OrderUpProductUpArea = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}`;

export const OrderUpPorudctUpBtn = styled.div`
    margin: 15px;
    cursor: pointer;
    border: 0 solid;
    border-radius: 5px;
    color:#fff;
    background:rgb(204, 65, 77);
    padding: 6px;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    
    &:hover{
        animation: buzz 0.8s ease-in-out;
    }
}`;

export const PasteFocusableSection = styled(DocumentSection)`
  &.paste-focus {
    outline-offset: -3px;
    background-color: rgba(76, 175, 80, 0.05);
    position: relative;
  }
  
  &.paste-focus::after {
    content: "파일 붙여넣기 가능 영역";
    position: absolute;
    bottom: 10px;
    right: 10px;
    background-color: #4CAF50;
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
    opacity: 0.9;
    animation: pulse 1.5s infinite;
  }
  
  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

export const PasteHintWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover .tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateY(5px); /* 아래로 자연스럽게 */
  }
`;

export const PasteHintHoverBox = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #fff;
  background-color: #4CAF50;
  padding: 5px 10px;
  border-radius: 6px;
  font-weight: 600;
  box-shadow: 0 3px 6px rgba(0,0,0,0.15);
  cursor: pointer;
  animation: fadeIn 0.4s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ClipboardIconWrapper = styled.span`
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  animation: bounce 1.2s infinite;

  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-4px); }
  }
`;

export const PasteHintTooltip = styled.div`
  position: absolute;
  top: 100%;
  right: 1%;
  transform: translate(-50%, 5px);
  background-color: #fff;
  color: #333;
  padding: 14px 20px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #eaeaea;
`;

// 유효기간 컨테이너
export const ValidityPeriodContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
`;

// 유효기간 입력 그룹
export const ValidityInputGroup = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

// 유효기간 라벨
export const ValidityLabel = styled.label`
  font-size: 12px;
  color: #666;
  min-width: 40px;
  font-weight: 500;
`;

// 유효기간 날짜 입력 필드
export const ValidityDateInput = styled.input`
  width: 120px;
  padding: 4px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #fb8b24;
    box-shadow: 0 0 0 2px rgba(251, 139, 36, 0.2);
  }
  
  &:hover {
    border-color: #fb8b24;
  }
`;

// 청구 프로세스 컨테이너 - 컴팩트한 정부 스타일
export const ClaimProcessContainer = styled.div`
  margin: 20px 0;
  padding: 24px 24px 0 24px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #16a34a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    border-radius: 12px;
  }
`;

// 프로세스 단계들 컨테이너 - 가로 배치
export const ProcessStepsContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 24px;
    left: 60px;
    right: 60px;
    height: 2px;
    background: #e2e8f0;
    z-index: 1;
  }
`;

// 개별 프로세스 단계 - 컴팩트한 카드 스타일
export const ProcessStep = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  z-index: 2;
  min-height: 120px;
`;

// 단계 아이콘 컨테이너
export const StepIconContainer = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  border: 3px solid ${props => {
    if (props.active) return '#16a34a';
    if (props.inProgress) return '#eab308';
    return '#e2e8f0';
  }};
  background: ${props => {
    if (props.active) return '#f0fdf4';
    if (props.inProgress) return '#fefce8';
    return '#f8fafc';
  }};
  color: ${props => {
    if (props.active) return '#16a34a';
    if (props.inProgress) return '#eab308';
    return '#e2e8f0';
  }};
  
  ${props => props.active && `
    box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);
    transform: scale(1.05);
  `}
  
  ${props => props.inProgress && `
    box-shadow: 0 4px 12px rgba(234, 179, 8, 0.3);
    transform: scale(1.05);
  `}
`;

// 단계 제목
export const StepTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

// 단계 버튼 - 정부 스타일
export const StepButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 10px;
  min-width: 120px;
  justify-content: center;
  
  background: #16a34a;
  color: white;
  box-shadow: 0 2px 4px rgba(22, 163, 74, 0.3);
  
  &:hover {
    background: #15803d;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(22, 163, 74, 0.4);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(22, 163, 74, 0.3);
  }
`;

// 단계 상태 - 컴팩트한 배지
export const StepStatus = styled.div`
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  
  &.completed {
    background: #dcfce7;
    color: #166534;
  }
  
  &.in-progress {
    background: #fef3c7;
    color: #92400e;
  }
  
  &.pending {
    background: #f1f5f9;
    color: #64748b;
  }
`;

// PDF 미리보기 컨테이너 - 더 큰 크기로 설정
export const PdfPreviewContainer = styled.div`
  width: 100%;
  min-width: 900px;  // 최소 너비 설정
  height: 85vh;      // 높이도 약간 증가
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

// PDF 미리보기 헤더
export const PdfPreviewHeader = styled.div`
  padding: 12px 16px;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  h3 {
    margin: 0;
    color: #333;
    font-size: 16px;
    font-weight: 600;
  }
`;

// PDF iframe - 더 큰 크기로 설정
export const PdfIframe = styled.iframe`
  width: 100%;
  height: 100%;
  min-width: 900px;  // 최소 너비 설정
  border: none;
  flex: 1;
  background: white;
`;

// PreviewContent 수정 - PDF 미리보기를 위한 더 큰 크기
export const PreviewContentPdf = styled.div`
  background: white;
  padding: 0;  // PDF 미리보기에서는 패딩 제거
  border-radius: 12px;
  position: relative;
  max-width: 85vw;    // 화면 너비의 95% 사용
  max-height: 85vh;   // 화면 높이의 95% 사용
  min-width: 900px;   // 최소 너비 설정
  width: 80vw;        // 기본 너비를 화면의 90%로 설정
  height: 80vh;       // 기본 높이를 화면의 90%로 설정
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const RequiredDocsButton = styled.button`
    cursor: pointer;
    border: 0 solid;
    border-radius: 5px;
    color: #fff;
    background: #0f4c5c;
    padding: 6px;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-left: 10px;
    gap: 5px;
    
    &:hover{
        animation: buzz 0.8s ease-in-out;
    }
`;

export const ClaimServiceBtn = styled.button`
    cursor: pointer;
    border: 0 solid;
    border-radius: 5px;
    color: #fff;
    background: #0f4c5c;
    padding: 6px;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-left: 10px;
    gap: 5px;
    
    &:hover{
        animation: buzz 0.8s ease-in-out;
    }
`;

// ============================================
// 결제 이력 스타일 (대여 이력과 동일한 스타일)
// ============================================

// 결제 이력 컨테이너
export const RentalHistoryContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: #fff5e6;
    border: 2px solid #fb8b24;
    border-radius: 10px;
    overflow: hidden;
    box-sizing: border-box;
    margin-top: 20px;
`;

// 결제 이력 리스트 컨테이너
export const RentalHistoryList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
`;

// 결제 이력 아이템
export const RentalHistoryItem = styled.div`
    margin-bottom: 0;
`;

// 결제 이력 카드
export const RentalHistoryCard = styled.div`
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    overflow: hidden;
`;

// 카드 헤더
export const RentalCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 12px;
    gap: 12px;
    flex-wrap: wrap;
`;

export const RentalCardContent = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    flex-wrap: wrap;
    min-width: 0;
    overflow: hidden;
`;

export const RentalCardRight = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;

// 회차 뱃지
export const PeriodBadge = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 10px;
    background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
    color: #ffffff;
    font-size: 14px;
    border-radius: 6px;
    min-width: 50px;
    flex-shrink: 0;
    box-shadow: 0 2px 4px rgba(49, 130, 246, 0.2);
`;

// 구분선
export const InfoDivider = styled.div`
    width: 2px;
    height: 30px;
    background: #e5e8eb;
    flex-shrink: 0;
`;

// 기간 정보
export const PeriodInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
    flex-shrink: 0;
`;

export const PeriodLabel = styled.span`
    font-size: 13px;
    color: #8b95a1;
    font-weight: 500;
    line-height: 1;
`;

export const PeriodValue = styled.span`
    font-size: 13px;
    color: #191f28;
    font-weight: 600;
    letter-spacing: -0.3px;
    line-height: 1.3;
    white-space: nowrap;
`;

// 결제 정보 아이템
export const PaymentInfoItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
    flex-shrink: 0;
    align-items: center;
    text-align: center;
`;

export const PaymentLabel = styled.span`
    font-size: 13px;
    color: #8b95a1;
    font-weight: 500;
    line-height: 1;
    text-align: center;
`;

export const PaymentValue = styled.span`
    font-size: 13px;
    color: #191f28;
    font-weight: 600;
    letter-spacing: -0.3px;
    line-height: 1.3;
    white-space: nowrap;
    text-align: center;
`;

export const PaymentAmount = styled.span`
    font-size: 13px;
    color: #191f28;
    font-weight: 700;
    letter-spacing: -0.3px;
    line-height: 1.3;
    white-space: nowrap;
    text-align: center;
`;

// 삭제 버튼
export const DeleteButtonWrapper = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    color: #8b95a1;
    transition: all 0.2s ease;
    padding: 0;
    flex-shrink: 0;
    
    &:hover {
        background: #f2f4f6;
        color: #ef4444;
    }
    
    &:active {
        transform: scale(0.95);
    }
`;

// 메모 섹션
export const MemoSection = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
    flex-wrap: wrap;
    overflow: hidden;
`;

export const RentalMemoItem = styled.div`
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
    overflow: hidden;
`;

export const RentalMemoText = styled.div`
    font-size: 13px;
    color: #4e5968;
    line-height: 1.4;
    padding: 8px 10px;
    background: #f9fafb;
    border-radius: 6px;
    cursor: pointer;
    word-break: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
    
    &:hover {
        background: #f2f4f6;
    }
`;

// 메모 입력 필드
export const HistoryMemoInput = styled.input`
    padding: 8px 10px;
    border: 2px solid #0f4c5c;
    border-radius: 6px;
    font-size: 13px;
    color: #191f28;
    background: #ffffff;
    font-family: inherit;
    flex: 1;
    min-width: 0;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 4px rgba(49, 130, 246, 0.1);
    }
    
    &::placeholder {
        color: #cbd5e0;
    }
`;

// 결제 이력 토글 버튼
export const ToggleHistoryButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 12px;
    margin-top: 12px;
    background: #ffffff;
    border: 1px solid #e5e8eb;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #0f4c5c;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background: #f8f9fa;
        border-color: #0f4c5c;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(49, 130, 246, 0.1);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

// 통계 섹션
export const RentalHistoryStats = styled.div`
    margin-top: 20px;
`;

export const StatsContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const StatsCardItem = styled.div`
    margin-bottom: 0;
`;

export const StatsCard = styled.div`
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    transition: all 0.2s ease;
    
    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
    }
`;

export const StatsCardHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 10px;
    gap: 24px;
    flex-wrap: wrap;
`;

export const StatsInfoItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    flex: 1;
    min-width: 0;
`;

export const StatsDivider = styled.div`
    width: 1px;
    height: 40px;
    background: #e5e8eb;
    flex-shrink: 0;
`;

export const StatsTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #191f28;
    letter-spacing: -0.5px;
    line-height: 1.4;
    margin-left: 50px;
    margin-right: 50px;
`;

export const StatsLabel = styled.div`
    font-size: 13px;
    font-weight: 500;
    color: #8b95a1;
    letter-spacing: 0.3px;
`;

export const StatsValue = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #191f28;
    letter-spacing: -0.5px;
    line-height: 1.4;
`;

export const StatsUnpaidAmount = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #ef4444;
    letter-spacing: -0.5px;
`;

// 결제 상태 아이템
export const PaymentStatusItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex-shrink: 0;
    align-items: center;
    text-align: center;
`;

// 결제 상태 배지
export const PaymentStatusBadge = styled.span`
    font-size: 13px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
    white-space: nowrap;
    text-align: center;
    
    ${props => {
        switch (props.status) {
            case 'paid': // 납부/완료
                return `
                    color: #16a34a;
                `;
            case 'unpaid': // 미납/미완료
                return `
                    color: #dc2626;
                `;
            case 'pending': // 대기
                return `
                    color: #6b7280;
                `;
            default:
                return `
                    color: #6b7280;
                `;
        }
    }}
`;

// 입금 처리 선택기 컨테이너
export const PaymentStatusSelector = styled.div`
    display: flex;
    gap: 6px;
    align-items: center;
`;

// 입금 처리 상태 선택 버튼
export const PaymentStatusButton = styled.button`
    padding: 4px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background-color: ${props => props.active ? '#2563eb' : '#ffffff'};
    color: ${props => props.active ? '#ffffff' : '#333333'};
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background-color: ${props => props.active ? '#1d4ed8' : '#f5f5f5'};
        border-color: ${props => props.active ? '#1d4ed8' : '#d0d0d0'};
    }
    
    &:active {
        transform: scale(0.98);
    }
`;

// 센터 사이드 (제목 영역)
export const CenterSide = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CenterContent = styled.div`
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 18px;
    font-weight: 600;
    display: inline-block;
    position: relative;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    background-color: #f8f1e9;
    color: #cc5803;
    border: 2px solid #cc5803;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }
`;